/* eslint-disable max-len */
import { useEffect, useRef, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import { useAtomValue, useAtom, useSetAtom } from 'jotai';
import {
  allKmzs,
  kmzNetwork,
  openKmzBar,
  partnerForkmzNetwork,
  selectedDisplayedKmz,
  filteredKmzForDisplayed,
  routeSelection,
  noNetwork,
  partnerNetwork,
  selectedRoutePath,
  leasingPoints,
  selectedNavRoute,
  selectedNavRouteAtom,
  mapMarkersOnSelectedRoute,
  openRouteNamePopUp,
  openCostModal,
} from '../../common/atom/atoms';
import KmzButtonsComponent from '../Kmz/kmz_buttons.component';
import { useBackdrop } from '../../common/components/backDrop_context.component';
import { pakBoundryLayer } from '../../common/functions/pak_boundry.function';
import { removeWmsLayer } from '../../common/functions/remove_wms_layer.function';
import { removeWmsSitesLayer } from '../../common/functions/remove_wms_site_layers.function';
import { handleRefresh } from '../../common/functions/refresh_map.function';
import { addWmsLayer } from '../../common/functions/add_wms_layer.function';
import PartnerAndNetwrokButtons from '../Kmz/partner_and_network_button.component';
import RefreshMap from '../../common/components/refresh_map_component';
import { addRouteForPoc } from '../Poc/functions/add_route_for_poc.function';
import { notify } from '../../common/functions/react-toastify.function';
import { decodeGeometry } from '../../common/functions/decode_geometry_to_geojson.function';
import AddRouteButton from '../Kmz/add_Route_button.component';
import {
  getRouteOneAdditionlCount,
  getRouteOneAdditionlForPoc,
  getRouteOneForPoc,
} from '../Poc/functions/get_routes_for_poc.function';
import {
  getRingOneAdditionlCount,
  getRingOneAdditionlForPoc,
} from './functions/get_ring_routes_for_poc.function';
import * as turf from '@turf/turf';
import axios from 'axios';
import { loadonMapPoc } from '../Kmz/functions/load_on_map.poc.function';
import PocEstimationModalCost from '../Poc/poc_cost_modal.component';
import PocEstimationModal from '../Poc/poc_estimation_modal.component';
import { removeAdditionalRoutes } from '../Kmz/functions/remove_Additional_routes_response.function';
import { getCenterFromCoordinates } from '../../common/functions/get_center_from_coordinates.function';
import { geoServerSites } from '../../common/functions/get_geoServer_sites.function';
import CreateRingRoute from './create_ring_route.component';
import RingNameModal from './ring_name_modal.component';
import { createRing } from './functions/create_ring.function';

mapboxgl.accessToken = process.env.REACT_APP_PUBLIC_MAP_BOX_GL_ACCESS_TOKEN;

const RingPlanningMap = (props) => {
  const {
    getAllKmz,
    getAllRoutes,
    setKmzData,
    filters,
    selectedRingRoutes,
    selectedRingId,
    onRingZoomComplete,
  } = props;
  const mapContainer = useRef(null);
  const controllerRef = useRef(null);
  const [totalRouteCost, setTotalRouteCost] = useState(null);
  const [openCost, setOpenCost] = useAtom(openCostModal);
  const [openRingCost, setOpenRingCost] = useState(false);
  const [selectedRouteAdditional, setSelectedRouteAdditional] = useState(null);
  const [selectedRingAdditional, setSelectedRingAdditional] = useState(null);
  const [oldSelectedRingNav, setOldSelectedRingNav] = useState(null);
  const [kmzBarValue, setKmzLeftBar] = useAtom(openKmzBar);
  const [routeName, setRouteName] = useState('');
  const [ringDescription, setRingDescription] = useState('');
  const setSelectedRoutePath = useSetAtom(selectedRoutePath);
  const partnerNetworkValue = useAtomValue(partnerNetwork);
  let currentPopup = null;
  const { showBackdrop, hideBackdrop } = useBackdrop();
  const map = useRef(null);
  const [filteredKmzDataForDisplayed, setFilteredKmzForDisplayed] =
    useAtom(filteredKmzForDisplayed);
  const kmzAll = useAtomValue(allKmzs);
  const [routeSelectionValue, setRouteSelection] = useAtom(routeSelection);
  const leasingPointsValue = useAtomValue(leasingPoints);
  const noNetworks = useAtomValue(noNetwork);
  const currentKmzNetwork = useAtomValue(kmzNetwork);
  const kmzPartner = useAtomValue(partnerForkmzNetwork);
  const [ids, setIDs] = useAtom(selectedDisplayedKmz);
  const [lng, setLng] = useState(69.3451);
  const [lat, setLat] = useState(30.3753);
  const stepRef = useRef(0);
  const [sitePopupFlag, setSitePopupFlag] = useState(false);
  const [createRoutePopup, setCreateRoutePopup] = useState(false);
  const [markers, setMarkers] = useState([]);
  const [alternativeRoutes, setAlternativeRoutes] = useState([]);
  const [oldSelectedNav, setOldSelectedNav] = useState(null);
  const [selectedNav, setSelectedNav] = useState(null);
  const [selectedRouteNavItem, setSelectedRouteNavItem] = useAtom(selectedNavRouteAtom);
  const [removeMarkersSubRoute, setRemoveMarkersSubRoute] = useState(false);
  const [selectedRoute, setSelectedRoute] = useState(null);
  const [isToggled, setIsToggled] = useState(false); // State for the toggle button
  const [suggestions, setSuggestions] = useState([]); // Store location suggestions
  const [strArray, setStrArray] = useState(['', '']);
  const [mapMarkers, setMapMarkers] = useAtom(mapMarkersOnSelectedRoute);
  const [submitAdditional, setSubmitAdditional] = useState(false);
  const [openPocModalCost, setOpenPocModalCost] = useAtom(openRouteNamePopUp);
  const [multipleRoutes, setMultipleRoutes] = useState([]); // Store multiple routes for selection
  const [showRouteSelectionPopup, setShowRouteSelectionPopup] = useState(false); // Control route selection popup
  const [selectedRouteIndex, setSelectedRouteIndex] = useState(null); // Track which route is selected

  // New state for pairwise route segments
  const [routeSegments, setRouteSegments] = useState({}); // Store route options for each segment
  const [selectedSegments, setSelectedSegments] = useState({}); // Store selected route for each segment
  const [showRingConnection, setShowRingConnection] = useState(false); // Checkbox for last-to-first connection
  const [currentSegmentIndex, setCurrentSegmentIndex] = useState(null); // Track which segment is being selected
  const [ringRouteMarkers, setRingRouteMarkers] = useState([]); // Store markers for ring routes
  const [displayedRingRoutesCount, setDisplayedRingRoutesCount] = useState(0); // Track number of displayed ring routes
  console.log('==>', selectedSegments);
  useEffect(() => {
    if (map.current) {
      map.current.resize();
    } // delay to allow DOM transition to complete
  }, [kmzBarValue]);

  useEffect(() => {
    if (!map.current) {
      map.current = new mapboxgl.Map({
        container: mapContainer.current,
        style: 'mapbox://styles/mapbox/standard',
        center: [lng, lat],
        zoom: 2,
        attributionControl: false,
      });
      map.current.addControl(new mapboxgl.NavigationControl(), 'bottom-right');
      map.current.on('style.load', () => {
        console.log('Style fully loaded, adding boundary...');
        pakBoundryLayer(map.current);
        updateLayer();
      });
    } else {
      map.current.setCenter([lng, lat]);
    }
  }, []);

  const updateLayer = () => {
    showBackdrop();
    removeLayer();
    removeWmsLayer(map);
    removeWmsSitesLayer(map);
    if (!map.current) {
      return;
    }
    if (controllerRef.current) {
      controllerRef.current.abort();
    }
    controllerRef.current = new AbortController();
    addWmsLayer(
      map,
      currentKmzNetwork,
      currentPopup,
      stepRef,
      showBackdrop,
      hideBackdrop,
      controllerRef.current
    );
    hideBackdrop();
    // addWmsSitesLayer(map, currentKmzNetwork, setSitePopupFlag, controllerRef.current)
    addWmsSitessLayer(controllerRef.current);
  };
  const addWmsSitessLayer = async (controller) => {
    let tab = currentKmzNetwork.toLowerCase();

    try {
      // Remove existing layers and sources if they exist
      if (map.current.getLayer('sitesLayers')) {
        map.current.removeLayer('sitesLayers');
      }
      if (map.current.getLayer('highlightedSites')) {
        map.current.removeLayer('highlightedSites');
      }
      if (map.current.getSource('sitesLayers')) {
        map.current.removeSource('sitesLayers');
      }

      // Stop any existing animation
      if (window.haloAnimationFrame) {
        cancelAnimationFrame(window.haloAnimationFrame);
      }

      const data = await geoServerSites(currentKmzNetwork, controller.signal);

      if (!data) {
        console.log('request aborted by user');
        return;
      }

      map.current.addSource('sitesLayers', {
        type: 'geojson',
        data: data,
      });

      // Add your layers as before...
      map.current.addLayer({
        id: 'sitesLayers',
        type: 'circle',
        source: 'sitesLayers',
        paint: {
          // 'circle-radius': 3,
          'circle-color': '#4B0082',
          'circle-stroke-color': '#9370DB',
          'circle-stroke-width': 2.5 / 1.8,
          'circle-stroke-opacity': 0.4,
          'circle-radius': ['interpolate', ['linear'], ['zoom'], 5, 3, 15, 10],
        },
      });
      map.current.addLayer({
        id: 'highlightedSites',
        type: 'circle',
        source: 'sitesLayers',
        paint: {
          'circle-radius': 4, // Slightly larger radius for highlighted sites
          'circle-color': '#e813c1', // Highlighted color (e.g., tomato red)
          'circle-stroke-color': '#e813c1', // Stroke color for highlighted sites
          'circle-stroke-width': 2,
          'circle-stroke-opacity': 0.6,
          'circle-opacity': 1, // Higher opacity for the highlighted layer
        },
        filter: ['==', 'highlighted', true], // Initially, no sites are highlighted
      });
      // ... rest of your layer additions and animation code
      let haloSize = 3; // Initial size
      let opacity = 0.5; // Initial opacity
      let expanding = true; // Flag for expanding or shrinking
      let maxHaloSize = 6; // Max size of the halo
      let minHaloSize = 3; // Min size of the halo
      let maxOpacity = 0.7; // Max opacity of the halo
      let minOpacity = 0.3; // Min opacity of the halo

      const animateHalo = () => {
        // Expand or shrink halo size
        if (expanding) {
          haloSize += 0.05; // Increase size
          opacity += 0.02; // Increase opacity
          if (haloSize >= maxHaloSize || opacity >= maxOpacity) {
            expanding = false;
          }
        } else {
          haloSize -= 0.05; // Decrease size
          opacity -= 0.02; // Decrease opacity
          if (haloSize <= minHaloSize || opacity <= minOpacity) {
            expanding = true;
          }
        }

        // Update the paint properties for the circle layer
        map.current.setPaintProperty('highlightedSites', 'circle-radius', haloSize);
        map.current.setPaintProperty('highlightedSites', 'circle-opacity', opacity);

        // Continue the animation
        requestAnimationFrame(animateHalo);
      };

      animateHalo();
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Error adding WFS layer:', error);
      }
    }
  };

  const removeLayer = () => {
    const sourceId = 'networklines';
    const layerId = 'lines-layer-network';

    if (map.current.getLayer(layerId)) {
      map.current.removeLayer(layerId);
    }
    if (map.current.getSource(sourceId)) {
      map.current.removeSource(sourceId);
    }
  };
  const cancelRef = useRef(false);

  useEffect(() => {
    cancelRef.current = false;

    const handleLayers = async () => {
      if (noNetworks) {
        removeWmsLayer(map);
        removeWmsSitesLayer(map);
      } else {
        await updateLayer();

        if (cancelRef.current || noNetworks) {
          removeWmsLayer(map);
          removeWmsSitesLayer(map);
        }
      }
    };

    handleLayers();

    return () => {
      cancelRef.current = true;
      if (controllerRef.current) {
        controllerRef.current.abort();
      }
    };
  }, [currentKmzNetwork, noNetworks]);

  const handleClear = () => {
    setKmzLeftBar(false);
    setIDs([]);
    handleRefresh(map);
  };
  useEffect(() => {
    handleClear();
  }, [currentKmzNetwork]);
  //   useEffect(() => {
  //     showBackdrop();
  //     updateLayersOfKmzs(
  //       map,
  //       ids,
  //       currentKmzNetwork,
  //       kmzPartner,
  //       filteredKmzDataForDisplayed,
  //       setFilteredKmzForDisplayed,
  //       false
  //     );
  //     hideBackdrop();
  //   }, [ids]);

  const reomvalNewRouteCreation = async () => {
    await removePreviousLayersAndSources();
    setOldSelectedNav(null);
    setSelectedNav(null);
  };

  const cancelAllRoutes = () => {
    setStrArray([]);
    setIsToggled(false);
  };
  const handleToggle = () => {
    setIsToggled((prev) => !prev); // Toggle the button state
  };
  useEffect(() => {
    console.log('hellooo');
    setMarkers([]);
  }, [leasingPointsValue]);

  useEffect(() => {
    if (map.current) {
      const handleMapClick = (e) => {
        console.log('markersss');
        const { lng, lat } = e.lngLat;
        setMarkers((prevMarkers) => {
          let isSamePoint =
            prevMarkers.length > 0 &&
            prevMarkers[prevMarkers.length - 1].lng === lng &&
            prevMarkers[prevMarkers.length - 1].lat === lat;
          if (isSamePoint) {
            return prevMarkers;
          }

          const el = document.createElement('div');
          el.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#1f1f1f"><g><rect fill="none" height="24" width="24"/></g><g><g><path d="M7.3,14.7l1.2-1.2c-1-1-1.5-2.3-1.5-3.5c0-1.3,0.5-2.6,1.5-3.5L7.3,5.3c-1.3,1.3-2,3-2,4.7S6,13.4,7.3,14.7z"/><path d="M19.1,2.9l-1.2,1.2c1.6,1.6,2.4,3.8,2.4,5.9c0,2.1-0.8,4.3-2.4,5.9l1.2,1.2c2-2,2.9-4.5,2.9-7.1C22,7.4,21,4.9,19.1,2.9z"/><path d="M6.1,4.1L4.9,2.9C3,4.9,2,7.4,2,10c0,2.6,1,5.1,2.9,7.1l1.2-1.2c-1.6-1.6-2.4-3.8-2.4-5.9C3.7,7.9,4.5,5.7,6.1,4.1z"/><path d="M16.7,14.7c1.3-1.3,2-3,2-4.7c-0.1-1.7-0.7-3.4-2-4.7l-1.2,1.2c1,1,1.5,2.3,1.5,3.5c0,1.3-0.5,2.6-1.5,3.5L16.7,14.7z"/><path d="M14.5,10c0-1.38-1.12-2.5-2.5-2.5S9.5,8.62,9.5,10c0,0.76,0.34,1.42,0.87,1.88L7,22h2l0.67-2h4.67L15,22h2l-3.37-10.12 C14.16,11.42,14.5,10.76,14.5,10z M10.33,18L12,13l1.67,5H10.33z"/></g></g></svg>`;
          const newMarker = new mapboxgl.Marker(el).setLngLat([lng, lat]).addTo(map.current);

          const updatedMarkers = [...prevMarkers, { lng, lat, marker: newMarker }];

          getDirections(updatedMarkers);

          updatedMarkers.forEach((marker, index) => {
            const markerEl = marker.marker.getElement();
            const svg = markerEl.querySelector('svg');
            const paths = svg.querySelectorAll('path');

            paths.forEach((path, i) => {
              if (i === 4 || i === 2 || i === 1) {
                // Tower base path – keep black
                path.setAttribute('fill', '#1f1f1f');
              } else {
                // Only color signal waves based on position
                if (index === 0) {
                  path.setAttribute('fill', 'red');
                } else if (index === updatedMarkers.length - 1 && !leasingPointsValue) {
                  path.setAttribute('fill', 'green');
                } else {
                  path.setAttribute('fill', 'blue');
                }
              }
            });
          });
          return updatedMarkers;
        });
      };

      if (routeSelectionValue) {
        setMarkers((prevMarkers) => {
          getDirections(prevMarkers);
          return prevMarkers;
        });

        map.current.on('click', handleMapClick);
        reomvalNewRouteCreation();
      } else {
        map.current.off('click', handleMapClick);

        setMarkers((prevMarkers) => {
          prevMarkers.forEach((m) => m.marker.remove());
          return [];
        });

        if (map.current.getLayer('selected-route')) {
          map.current.removeLayer('selected-route');
          map.current.removeSource('selected-route');
        }

        if (map.current.getLayer('highlightedSites')) {
          map.current.setFilter('highlightedSites', ['in', 'site_id', ...[]]);
          map.current.setFilter('highlightedSites', ['in', 'site code', ...[]]);
        }

        setAlternativeRoutes([]);

        if (map.current.getLayer('route')) {
          map.current.removeLayer('route');
          map.current.removeSource('route');
        }
      }

      return () => {
        if (!routeSelectionValue) {
          setMarkers((prevMarkers) => {
            prevMarkers.forEach((m) => m.marker.remove());
            return [];
          });
        }

        if (map.current.getLayer('selected-route')) {
          map.current.removeLayer('selected-route');
          map.current.removeSource('selected-route');
        }

        if (leasingPointsValue) {
          setAlternativeRoutes([]);
        }

        if (map.current.getLayer('route')) {
          map.current.removeLayer('route');
          map.current.removeSource('route');
        }

        map.current.off('click', handleMapClick);
      };
    }
  }, [map, routeSelectionValue, setSelectedRoute, isToggled, leasingPointsValue]);

  useEffect(() => {
    if (removeMarkersSubRoute) {
      // Remove markers
      setMapMarkers((prevState) => {
        prevState.forEach((m) => m.marker.remove());
        return [];
      });

      // Remove route layers
      if (map.current) {
        // Remove route-plot layer and source
        if (map.current.getLayer('route-plot')) {
          map.current.removeLayer('route-plot');
        }
        if (map.current.getSource('route')) {
          map.current.removeSource('route');
        }

        // Remove multiple-routes layer and source
        if (map.current.getLayer('multiple-routes')) {
          map.current.removeLayer('multiple-routes');
        }
        if (map.current.getSource('multiple-routes')) {
          map.current.removeSource('multiple-routes');
        }

        // Remove selected-route layer and source
        if (map.current.getLayer('selected-route')) {
          map.current.removeLayer('selected-route');
        }
        if (map.current.getSource('selected-route')) {
          map.current.removeSource('selected-route');
        }
      }

      // Clear route selection states
      setSelectedRoute(null);
      setMultipleRoutes([]);
      setShowRouteSelectionPopup(false);
      setSelectedRouteIndex(null);
      setAlternativeRoutes([]);

      setRemoveMarkersSubRoute(false);
    }
  }, [removeMarkersSubRoute]);
  const fetchRoutes = async () => {
    if (!leasingPointsValue) {
      return;
    }
    try {
      if (!map) {
        return;
      }
      if (!selectedNav) {
        return;
      }
      console.log(selectedNav);
      const mapInstance = map;
      let routesData = await getRouteOneForPoc(selectedNav);
      map.current.flyTo({
        center: [
          routesData[0].geoJSON.coordinates[0][0],
          routesData[0].geoJSON.coordinates[routesData[0].geoJSON.coordinates.length - 1][1],
        ],
        zoom: 10,
        duration: 2000, // Adjust duration for smoother transition
      });
      routesData.forEach((route, index) => {
        console.log(route);
        const routeGeoJSON = {
          type: 'Feature',
          geometry: {
            type: 'LineString',
            coordinates: route.geoJSON.coordinates, // Assuming geoJSON is directly available
          },
        };

        // Add a larger hitbox layer for the route (invisible, but larger clickable area)
        // Add an invisible hitbox layer for the route
        if (!mapInstance.getSource(`route-hitbox-${index}`)) {
          mapInstance.addSource(`route-hitbox-${index}`, {
            type: 'geojson',
            data: routeGeoJSON,
          });

          mapInstance.addLayer({
            id: `route-hitbox-layer-${index}`,
            type: 'line',
            source: `route-hitbox-${index}`,
            layout: {
              'line-join': 'round',
              'line-cap': 'round',
            },
            paint: {
              'line-color': 'transparent', // Make it invisible
              'line-width': 5, // Increase the width for the hitbox
            },
          });
        }
        // Check if source for the route already exists
        if (!mapInstance.getSource(`route-${index}`)) {
          mapInstance.addSource(`route-${index}`, {
            type: 'geojson',
            data: routeGeoJSON,
          });

          mapInstance.addLayer({
            id: `route-layer-${index}`,
            type: 'line',
            source: `route-${index}`,
            layout: {
              'line-join': 'round',
              'line-cap': 'round',
            },
            paint: {
              'line-color': '#fc6f03',
              'line-width': 5,
            },
          });
        }

        // Add hover effect for cursor pointer
        mapInstance.on('mouseenter', `route-hitbox-layer-${index}`, () => {
          mapInstance.getCanvas().style.cursor = 'pointer'; // Change cursor to pointer on hover
        });

        // Reset cursor when mouse leaves the route
        mapInstance.on('mouseleave', `route-hitbox-layer-${index}`, () => {
          mapInstance.getCanvas().style.cursor = ''; // Reset cursor style
        });
        mapInstance.on('click', `route-hitbox-layer-${index}`, (e) => {
          setSelectedRouteAdditional(route.id);
          setTotalRouteCost(route.totalCost);
          setRouteSelection(false);
          console.log(`Route clicked: ${route.id}`);
          const clickedPoint = e.lngLat; // Get clicked point's coordinates
          console.log('markers===>', mapMarkers);
          setMapMarkers((prevState) => {
            console.log('markers===>', prevState);

            if (prevState.length >= 2) {
              const isSamePoint =
                prevState.length > 0 &&
                prevState[prevState.length - 1].lng === clickedPoint.lng &&
                prevState[prevState.length - 1].lat === clickedPoint.lat;

              if (isSamePoint) {
                // If the new point is the same as the previous one, return the existing array (no new marker)
                console.log('Marker is on the same point, not adding a new one.');
                return prevState;
              }

              // If two markers are already present, clear them
              prevState.forEach((m) => m.marker.remove());
              console.log('====markers====', prevState);
              return [];
            } else if (prevState.length < 2) {
              // Create a new marker
              const isSamePoint =
                prevState.length > 0 &&
                prevState[prevState.length - 1].lng === clickedPoint.lng &&
                prevState[prevState.length - 1].lat === clickedPoint.lat;

              if (isSamePoint) {
                // If the new point is the same as the previous one, return the existing array (no new marker)
                console.log('Marker is on the same point, not adding a new one.');
                return prevState;
              }

              const marker = new mapboxgl.Marker()
                .setLngLat([clickedPoint.lng, clickedPoint.lat])
                .addTo(mapInstance);
              console.log('here');
              // Update markers state
              return [...prevState, { lng: clickedPoint.lng, lat: clickedPoint.lat, marker }];

              // If we have two markers, fetch the route between them
              // if (prevState.length === 1) {
              //   fetchRouteBetweenMarkers(prevState[0], {
              //     lng: clickedPoint.lng,
              //     lat: clickedPoint.lat,
              //   });
              // }
            }
          });
          //  new mapboxgl.Marker()
          //   .setLngLat([clickedPoint.lng, clickedPoint.lat])
          //   .addTo(mapInstance);
        });
      });
      setOldSelectedNav(selectedNav);

      let additional = await getRouteOneAdditionlForPoc(selectedNav);
      console.log('additional===>', additional);
      additional.forEach((route, index) => {
        const routeGeoJSON = {
          type: 'Feature',
          geometry: {
            type: 'LineString',
            coordinates: route.geoJSON.coordinates, // Assuming geoJSON is directly available
          },
        };
        if (!mapInstance.getSource(`additional-route-${index}`)) {
          mapInstance.addSource(`additional-route-${index}`, {
            type: 'geojson',
            data: routeGeoJSON,
          });
          console.log('hhhhhhhhh');
          mapInstance.addLayer({
            id: `additional-route-layer-${index}`,
            type: 'line',
            source: `additional-route-${index}`,
            layout: {
              'line-join': 'round',
              'line-cap': 'round',
            },
            paint: {
              'line-color': '#000000',
              'line-width': 5,
            },
          });
        }
      });
    } catch (error) {
      console.error('Error fetching routes:', error);
    }
  };
  const removePreviousLayersAndSources = async () => {
    if (!map) {
      return;
    }
    if (!selectedNav || !oldSelectedNav) {
      return;
    }
    setRemoveMarkersSubRoute(true);
    const mapInstance = map;
    const routeLayerId = `route-layer-${0}`;
    const routeHitboxLayerId = `route-hitbox-layer-${0}`;
    const routeSourceId = `route-${0}`;
    const hitboxSourceId = `route-hitbox-${0}`;
    const countAdditional = await getRouteOneAdditionlCount(oldSelectedNav);

    // Remove route layers and sources if they exist
    if (mapInstance.getLayer(routeLayerId)) {
      mapInstance.removeLayer(routeLayerId);
    }
    if (mapInstance.getSource(routeSourceId)) {
      mapInstance.removeSource(routeSourceId);
    }
    if (mapInstance.getLayer(routeHitboxLayerId)) {
      mapInstance.removeLayer(routeHitboxLayerId);
    }
    if (mapInstance.getSource(hitboxSourceId)) {
      mapInstance.removeSource(hitboxSourceId);
    }
    removeAdditionalRoutes(mapInstance, countAdditional);
  };
  const addAdditional = async () => {
    if (!map) {
      return;
    }
    if (!leasingPointsValue) {
      return;
    }
    const mapInstance = map;
    let additional = await getRouteOneAdditionlForPoc(selectedNav);
    additional.forEach((route, index) => {
      const routeGeoJSON = {
        type: 'Feature',
        geometry: {
          type: 'LineString',
          coordinates: route.geoJSON.coordinates, // Assuming geoJSON is directly available
        },
      };
      if (!mapInstance.getSource(`additional-route-${index}`)) {
        mapInstance.addSource(`additional-route-${index}`, {
          type: 'geojson',
          data: routeGeoJSON,
        });
        mapInstance.addLayer({
          id: `additional-route-layer-${index}`,
          type: 'line',
          source: `additional-route-${index}`,
          layout: {
            'line-join': 'round',
            'line-cap': 'round',
          },
          paint: {
            'line-color': '#000000',
            'line-width': 5,
          },
        });
      }
    });
    setMapMarkers((prevState) => {
      prevState.forEach((m) => m.marker.remove());
      return [];
    });
  };
  const romveAdd = async () => {
    if (!map) {
      return;
    }
    if (!leasingPointsValue) {
      return;
    }
    const mapInstance = map;
    const countAdditional = await getRouteOneAdditionlCount(oldSelectedNav);
    removeAdditionalRoutes(mapInstance, countAdditional);
  };

  // Ring additional routes functions
  const addRingAdditional = async () => {
    if (!map.current) {
      return;
    }
    const mapInstance = map.current;
    try {
      let additional = await getRingOneAdditionlForPoc(selectedRingId);
      console.log('Ring additional routes response:', additional);

      if (additional && Array.isArray(additional)) {
        additional.forEach((route, index) => {
          if (route.geoJSON && route.geoJSON.coordinates) {
            const routeGeoJSON = {
              type: 'Feature',
              geometry: {
                type: 'LineString',
                coordinates: route.geoJSON.coordinates,
              },
            };
            if (!mapInstance.getSource(`ring-additional-route-${index}`)) {
              mapInstance.addSource(`ring-additional-route-${index}`, {
                type: 'geojson',
                data: routeGeoJSON,
              });
              mapInstance.addLayer({
                id: `ring-additional-route-layer-${index}`,
                type: 'line',
                source: `ring-additional-route-${index}`,
                layout: {
                  'line-join': 'round',
                  'line-cap': 'round',
                },
                paint: {
                  'line-color': '#000000',
                  'line-width': 5,
                },
              });
            }
          }
        });
      } else {
        console.log('No additional routes found or invalid response format');
      }
    } catch (error) {
      console.error('Error fetching ring additional routes:', error);
    }

    setMapMarkers((prevState) => {
      prevState.forEach((m) => m.marker.remove());
      return [];
    });
  };

  const removeRingAdditional = async () => {
    if (!map.current) {
      return;
    }
    const mapInstance = map.current;
    // Clean up all possible additional routes without API call
    for (let i = 0; i < 20; i++) {
      const additionalLayerId = `ring-additional-route-layer-${i}`;
      const additionalSourceId = `ring-additional-route-${i}`;
      if (mapInstance.getLayer(additionalLayerId)) {
        mapInstance.removeLayer(additionalLayerId);
      }
      if (mapInstance.getSource(additionalSourceId)) {
        mapInstance.removeSource(additionalSourceId);
      }
    }
  };

  const removeRingAdditionalRoutes = (mapInstance, countAdditional) => {
    if (!countAdditional?.response) {
      return;
    }
    for (let i = 0; i <= parseInt(countAdditional.response); i++) {
      const additionalLayerId = `ring-additional-route-layer-${i}`;
      const additionalSourceId = `ring-additional-route-${i}`;
      if (mapInstance.getLayer(additionalLayerId)) {
        mapInstance.removeLayer(additionalLayerId);
      }
      if (mapInstance.getSource(additionalSourceId)) {
        mapInstance.removeSource(additionalSourceId);
      }
    }
  };

  useEffect(() => {
    // Call function to remove previous layers before adding new ones
    if (!leasingPointsValue) {
      return;
    }
    const execute = async () => {
      if (selectedNav != null) {
        setRouteSelection(false);
      }
      await removePreviousLayersAndSources();
      await fetchRoutes();
    };
    execute();
  }, [selectedNav, leasingPointsValue]);

  useEffect(() => {
    // Call function to remove previous layers before adding new ones
    if (!leasingPointsValue) {
      return;
    }
    const execute = async () => {
      await romveAdd();
      await addAdditional();
    };
    if (submitAdditional) {
      execute();
      setSubmitAdditional(false);
    }
  }, [submitAdditional]);

  // Handle ring additional routes when ring is selected - now handled in displayRingRoutes
  // useEffect(() => {
  //   const execute = async () => {
  //     if (selectedRingId != null) {
  //       setRouteSelection(false);
  //     }
  //     await removeRingAdditional();
  //     await addRingAdditional();
  //   };
  //   if (selectedRingId) {
  //     execute();
  //   }
  // }, [selectedRingId]);

  // Handle ring additional routes cleanup and addition on submit
  useEffect(() => {
    const execute = async () => {
      await removeRingAdditional();
      await addRingAdditional();
    };
    if (submitAdditional && selectedRingId) {
      execute();
      setSubmitAdditional(false);
    }
  }, [submitAdditional, selectedRingId]);
  useEffect(() => {
    if (!map.current) {
      return;
    }
    if (mapMarkers.length == 2) {
      fetchRouteBetweenMarkers(mapMarkers[0], mapMarkers[1]);
    } else {
      if (map.current.getLayer('route-plot')) {
        map.current.removeLayer('route-plot');
        if (map.current.getSource('route')) {
          map.current.removeSource('route');
        }
      }
    }
  }, [mapMarkers]);

  const getDirections = async (updatedMarkers) => {
    try {
      setAlternativeRoutes([]);
      const points = updatedMarkers.map((m) => [m.lng, m.lat]);

      if (updatedMarkers.length < 2) {
        return; // Need at least 2 markers for segments
      }

      // Clear existing route segments
      setRouteSegments({});
      setSelectedSegments({});

      // Remove existing route layers
      clearAllRouteLayers();

      // Calculate pairwise segments
      const segments = [];
      for (let i = 0; i < updatedMarkers.length - 1; i++) {
        segments.push({
          start: updatedMarkers[i],
          end: updatedMarkers[i + 1],
          index: i,
        });
      }

      // Add last-to-first connection if checkbox is checked
      if (showRingConnection && updatedMarkers.length > 2) {
        segments.push({
          start: updatedMarkers[updatedMarkers.length - 1],
          end: updatedMarkers[0],
          index: updatedMarkers.length - 1,
        });
      }

      // Fetch routes for each segment
      for (const segment of segments) {
        await fetchSegmentRoutes(segment);
      }
    } catch (error) {
      console.error('Error fetching directions:', error);
    }
  };

  const fetchSegmentRoutes = async (segment) => {
    try {
      const waypoints = `${segment.start.lng},${segment.start.lat};${segment.end.lng},${segment.end.lat}`;
      const profiles = ['driving', 'walking', 'cycling'];
      let segmentRoutes = [];

      for (let profile of profiles) {
        const response = await axios.get(
          `https://api.mapbox.com/directions/v5/mapbox/${profile}/${waypoints}?steps=true&geometries=geojson&access_token=${mapboxgl.accessToken}`
        );

        if (response.data.routes.length > 0) {
          response.data.routes.forEach((route, index) => {
            segmentRoutes.push({
              profile,
              index,
              route: route,
              geometry: route.geometry,
              color: getRouteColor(profile, index),
              duration: route.duration,
              distance: route.distance,
            });
          });
        }
      }

      // Store routes for this segment
      setRouteSegments((prev) => ({
        ...prev,
        [segment.index]: segmentRoutes,
      }));

      // Auto-select first route for each segment
      if (segmentRoutes.length > 0) {
        setSelectedSegments((prev) => ({
          ...prev,
          [segment.index]: segmentRoutes[0],
        }));

        // Render the selected route
        renderSegmentRoute(segment.index, segmentRoutes[0]);
      }
    } catch (error) {
      console.error(`Error fetching routes for segment ${segment.index}:`, error);
    }
  };

  const clearAllRouteLayers = () => {
    if (!map.current) {
      return;
    }

    // Remove all existing route layers
    const layersToRemove = ['selected-route', 'route-plot', 'multiple-routes'];

    layersToRemove.forEach((layerId) => {
      if (map.current.getLayer(layerId)) {
        map.current.removeLayer(layerId);
      }
      if (map.current.getSource(layerId)) {
        map.current.removeSource(layerId);
      }
    });

    // Remove segment-specific layers from current state
    Object.keys(routeSegments).forEach((segmentIndex) => {
      const layerId = `segment-route-${segmentIndex}`;
      if (map.current.getLayer(layerId)) {
        map.current.removeLayer(layerId);
      }
      if (map.current.getSource(layerId)) {
        map.current.removeSource(layerId);
      }
    });
  };

  const renderSegmentRoute = (segmentIndex, routeData) => {
    if (!map.current || !routeData) {
      return;
    }

    const layerId = `segment-route-${segmentIndex}`;
    const sourceId = `segment-route-${segmentIndex}`;

    // Remove existing layer if it exists
    if (map.current.getLayer(layerId)) {
      map.current.removeLayer(layerId);
    }
    if (map.current.getSource(sourceId)) {
      map.current.removeSource(sourceId);
    }

    // Add new route layer
    map.current.addSource(sourceId, {
      type: 'geojson',
      data: {
        type: 'Feature',
        geometry: routeData.geometry,
      },
    });

    map.current.addLayer({
      id: layerId,
      type: 'line',
      source: sourceId,
      layout: {
        'line-join': 'round',
        'line-cap': 'round',
      },
      paint: {
        'line-color': routeData.color,
        'line-width': 6,
        'line-opacity': 0.8,
      },
    });
  };

  const fetchRouteBetweenMarkers = async (start, end) => {
    try {
      // Clear existing routes
      if (map.current.getLayer('route-plot')) {
        map.current.removeLayer('route-plot');
      }
      if (map.current.getSource('route')) {
        map.current.removeSource('route');
      }

      // Clear any existing multiple route layers
      if (map.current.getLayer('multiple-routes')) {
        map.current.removeLayer('multiple-routes');
      }
      if (map.current.getSource('multiple-routes')) {
        map.current.removeSource('multiple-routes');
      }

      const waypoints = `${start.lng},${start.lat};${end.lng},${end.lat}`;

      // Define profiles (driving, walking, cycling)
      const profiles = ['driving', 'walking', 'cycling'];
      let allRoutes = [];

      // Loop through each profile and get the directions
      for (let profile of profiles) {
        // Make the API call to get directions for the specified profile
        const response = await axios.get(
          `https://api.mapbox.com/directions/v5/mapbox/${profile}/${waypoints}?steps=true&geometries=geojson&access_token=${mapboxgl.accessToken}`
        );

        // Handle the response if routes are available
        if (response.data.routes.length > 0) {
          // Loop through each route and add it to the array
          response.data.routes.forEach((route, index) => {
            const routeGeoJson = route.geometry;
            allRoutes.push({
              profile,
              index,
              route: route,
              geometry: routeGeoJson,
              color: getRouteColor(profile, index),
              duration: route.duration,
              distance: route.distance,
            });
          });
        }
      }

      // Set multiple routes for selection
      setMultipleRoutes(allRoutes);
      setShowRouteSelectionPopup(true);

      // Add all routes to map with different colors
      if (allRoutes.length > 0) {
        const allRoutesGeoJSON = {
          type: 'FeatureCollection',
          features: allRoutes.map((routeData, idx) => ({
            type: 'Feature',
            geometry: routeData.geometry,
            properties: {
              id: idx,
              profile: routeData.profile,
              color: routeData.color,
              duration: routeData.duration,
              distance: routeData.distance,
            },
          })),
        };

        map.current.addSource('multiple-routes', {
          type: 'geojson',
          data: allRoutesGeoJSON,
        });

        map.current.addLayer({
          id: 'multiple-routes',
          type: 'line',
          source: 'multiple-routes',
          layout: {
            'line-join': 'round',
            'line-cap': 'round',
          },
          paint: {
            'line-color': ['get', 'color'],
            'line-width': 4,
            'line-opacity': 0.7,
          },
        });

        // Add hover effect for cursor pointer
        map.current.on('mouseenter', 'multiple-routes', () => {
          map.current.getCanvas().style.cursor = 'pointer';
        });

        // Reset cursor when mouse leaves the route
        map.current.on('mouseleave', 'multiple-routes', () => {
          map.current.getCanvas().style.cursor = '';
        });

        // Add click event to select route
        map.current.on('click', 'multiple-routes', (e) => {
          const features = map.current.queryRenderedFeatures(e.point, {
            layers: ['multiple-routes'],
          });
          if (features.length > 0) {
            const selectedRouteData = allRoutes[features[0].properties.id];
            if (currentSegmentIndex !== null) {
              // Handle segment route selection
              handleSegmentRouteSelection(currentSegmentIndex, selectedRouteData);
            } else {
              // Handle regular route selection
              handleRouteSelection(selectedRouteData, features[0].properties.id);
            }
          }
        });
      }
    } catch (error) {
      console.error('Error fetching multiple routes:', error);
    }
  };
  const loadonMap = (routeGeoJson, index) => {
    loadonMapPoc(routeGeoJson, index, setSelectedRoutePath, map, setSelectedRoute, markers, turf);
  };
  const handleRemoveItem = (index) => {
    const newItems = markers.filter((item, i) => {
      if (i !== index) {
        return item;
      }
      item.marker.remove();
    }); // Filter out the item at the given index

    newItems.forEach((marker, index) => {
      if (index == 0) {
        let elements = marker.marker.getElement();
        let svg = elements.querySelector('svg');
        let path = svg.querySelector('path');
        path.setAttribute('fill', 'red');
      } else if (index == newItems.length - 1) {
        // Make first and last markers red
        let elements = marker.marker.getElement();
        let svg = elements.querySelector('svg');
        let path = svg.querySelector('path');
        path.setAttribute('fill', 'green');
      } else {
        // Make other markers blue
        let elements = marker.marker.getElement();
        let svg = elements.querySelector('svg');
        let path = svg.querySelector('path');
        path.setAttribute('fill', 'blue');
      }
    });

    setMarkers(newItems);
    getDirections(newItems);
  };
  useEffect(() => {
    if (markers.length > 0) {
      let stringArray = [];
      markers.forEach((i) => {
        stringArray.push(`${i.lng},${i.lat}`);
      });
      setStrArray(stringArray);
    }
  }, [markers]);

  // Handle ring connection checkbox changes
  useEffect(() => {
    if (markers.length > 2) {
      getDirections(markers);
    }
  }, [showRingConnection]);

  // Display selected ring routes on map
  useEffect(() => {
    if (!map.current) {
      return;
    }

    // Clean up previous ring route layers and markers
    cleanupRingRouteLayers();

    if (!selectedRingRoutes || selectedRingRoutes.length === 0) {
      // Refresh map to zoom out when ring is deselected
      handleRefresh(map);
      return;
    }

    // Display ring routes
    displayRingRoutes(selectedRingRoutes);
  }, [selectedRingRoutes, selectedRingId]);

  const cleanupRingRouteLayers = () => {
    if (!map.current) {
      return;
    }

    // Remove all ring route markers
    ringRouteMarkers.forEach((marker) => {
      if (marker && marker.remove) {
        marker.remove();
      }
    });
    setRingRouteMarkers([]);

    // Remove ring additional routes - clean up all possible additional routes
    // Since we don't have the count, we'll try to remove up to 20 additional routes
    for (let i = 0; i < 20; i++) {
      const additionalLayerId = `ring-additional-route-layer-${i}`;
      const additionalSourceId = `ring-additional-route-${i}`;
      if (map.current.getLayer(additionalLayerId)) {
        map.current.removeLayer(additionalLayerId);
      }
      if (map.current.getSource(additionalSourceId)) {
        map.current.removeSource(additionalSourceId);
      }
    }

    // Remove ring route layers using the stored count
    for (let index = 0; index < displayedRingRoutesCount; index++) {
      const layerId = `ring-route-${index}`;
      const sourceId = `ring-route-${index}`;
      const hitboxLayerId = `ring-route-hitbox-${index}`;
      const hitboxSourceId = `ring-route-hitbox-${index}`;

      // Remove hitbox layer
      if (map.current.getLayer(hitboxLayerId)) {
        map.current.removeLayer(hitboxLayerId);
      }
      if (map.current.getSource(hitboxSourceId)) {
        map.current.removeSource(hitboxSourceId);
      }

      // Remove visible route layer
      if (map.current.getLayer(layerId)) {
        map.current.removeLayer(layerId);
      }
      if (map.current.getSource(sourceId)) {
        map.current.removeSource(sourceId);
      }
    }

    // Reset the count and states
    setDisplayedRingRoutesCount(0);
    setSelectedRingAdditional(null);
    setOldSelectedRingNav(null);
  };

  const displayRingRoutes = async (routes) => {
    if (!map.current || !routes || routes.length === 0) {
      return;
    }

    const newMarkers = [];
    const allCoordinates = [];

    // Display main ring routes first
    routes.forEach((route, index) => {
      if (!route.geoJSON || !route.geoJSON.coordinates) {
        return;
      }

      const coordinates = route.geoJSON.coordinates;
      allCoordinates.push(...coordinates);

      // Add route to map
      const routeGeoJSON = {
        type: 'Feature',
        geometry: route.geoJSON,
      };

      const layerId = `ring-route-${index}`;
      const sourceId = `ring-route-${index}`;
      const hitboxLayerId = `ring-route-hitbox-${index}`;
      const hitboxSourceId = `ring-route-hitbox-${index}`;

      // Add hitbox layer for click detection
      if (!map.current.getSource(hitboxSourceId)) {
        map.current.addSource(hitboxSourceId, {
          type: 'geojson',
          data: routeGeoJSON,
        });

        map.current.addLayer({
          id: hitboxLayerId,
          type: 'line',
          source: hitboxSourceId,
          layout: {
            'line-join': 'round',
            'line-cap': 'round',
          },
          paint: {
            'line-color': 'transparent',
            'line-width': 15, // Wider hitbox for easier clicking
          },
        });
      }

      // Add visible route layer
      if (!map.current.getSource(sourceId)) {
        map.current.addSource(sourceId, {
          type: 'geojson',
          data: routeGeoJSON,
        });

        map.current.addLayer({
          id: layerId,
          type: 'line',
          source: sourceId,
          layout: {
            'line-join': 'round',
            'line-cap': 'round',
          },
          paint: {
            'line-color': route.color || '#BD1D23',
            'line-width': 5,
          },
        });
      }

      // Add click handlers for marker placement
      map.current.on('mouseenter', hitboxLayerId, () => {
        map.current.getCanvas().style.cursor = 'pointer';
      });

      map.current.on('mouseleave', hitboxLayerId, () => {
        map.current.getCanvas().style.cursor = '';
      });

      map.current.on('click', hitboxLayerId, (e) => {
        setOldSelectedRingNav(selectedRingAdditional);
        setSelectedRingAdditional(selectedRingId); // Use ring ID instead of route ID
        setTotalRouteCost(route.totalCost);
        setRouteSelection(false);
        console.log(`Ring route clicked: ${route.id}, Ring ID: ${selectedRingId}`);
        const clickedPoint = e.lngLat;
        console.log('markers===>', mapMarkers);
        setMapMarkers((prevState) => {
          console.log('markers===>', prevState);

          if (prevState.length >= 2) {
            const isSamePoint =
              prevState.length > 0 &&
              prevState[prevState.length - 1].lng === clickedPoint.lng &&
              prevState[prevState.length - 1].lat === clickedPoint.lat;

            if (isSamePoint) {
              console.log('Marker is on the same point, not adding a new one.');
              return prevState;
            }

            // If two markers are already present, clear them
            prevState.forEach((m) => m.marker.remove());
            console.log('====markers====', prevState);
            return [];
          } else if (prevState.length < 2) {
            // Create a new marker
            const isSamePoint =
              prevState.length > 0 &&
              prevState[prevState.length - 1].lng === clickedPoint.lng &&
              prevState[prevState.length - 1].lat === clickedPoint.lat;

            if (isSamePoint) {
              return prevState;
            }

            const marker = new mapboxgl.Marker()
              .setLngLat([clickedPoint.lng, clickedPoint.lat])
              .addTo(map.current);
            return [...prevState, { lng: clickedPoint.lng, lat: clickedPoint.lat, marker }];
          }
        });
      });

      // Add markers at start and end positions
      const startCoord = coordinates[0];
      const endCoord = coordinates[coordinates.length - 1];

      // Create start marker (red)
      const startMarkerEl = document.createElement('div');
      startMarkerEl.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="red"><circle cx="12" cy="12" r="8"/></svg>`;
      const startMarker = new mapboxgl.Marker(startMarkerEl)
        .setLngLat(startCoord)
        .addTo(map.current);
      newMarkers.push(startMarker);

      // Create end marker (green)
      const endMarkerEl = document.createElement('div');
      endMarkerEl.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="green"><circle cx="12" cy="12" r="8"/></svg>`;
      const endMarker = new mapboxgl.Marker(endMarkerEl).setLngLat(endCoord).addTo(map.current);
      newMarkers.push(endMarker);
    });

    setRingRouteMarkers(newMarkers);
    // Store the number of routes we just displayed for cleanup later
    setDisplayedRingRoutesCount(routes.length);

    // Add additional ring routes (following KMZ pattern)
    try {
      let additional = await getRingOneAdditionlForPoc(selectedRingId);
      console.log('Ring additional routes response:', additional);

      if (additional && Array.isArray(additional)) {
        additional.forEach((route, index) => {
          if (route.geoJSON && route.geoJSON.coordinates) {
            const routeGeoJSON = {
              type: 'Feature',
              geometry: {
                type: 'LineString',
                coordinates: route.geoJSON.coordinates,
              },
            };
            if (!map.current.getSource(`ring-additional-route-${index}`)) {
              map.current.addSource(`ring-additional-route-${index}`, {
                type: 'geojson',
                data: routeGeoJSON,
              });
              map.current.addLayer({
                id: `ring-additional-route-layer-${index}`,
                type: 'line',
                source: `ring-additional-route-${index}`,
                layout: {
                  'line-join': 'round',
                  'line-cap': 'round',
                },
                paint: {
                  'line-color': '#000000',
                  'line-width': 5,
                },
              });
            }
          }
        });
      } else {
        console.log('No additional routes found or invalid response format');
      }
    } catch (error) {
      console.error('Error fetching ring additional routes:', error);
    }

    // Fit map to show all routes
    if (allCoordinates.length > 0) {
      const bounds = allCoordinates.reduce(
        (bounds, coord) => {
          return bounds.extend(coord);
        },
        new mapboxgl.LngLatBounds(allCoordinates[0], allCoordinates[0])
      );

      map.current.fitBounds(bounds, {
        padding: 100,
        duration: 1000,
      });

      // Call the callback when zoom animation completes
      if (onRingZoomComplete) {
        setTimeout(() => {
          onRingZoomComplete();
        }, 1000); // Match the duration of the fitBounds animation
      }
    } else if (onRingZoomComplete) {
      // If no coordinates, call callback immediately
      onRingZoomComplete();
    }
  };

  const handleSearch = async (location, index) => {
    setStrArray((prev) => {
      prev[index] = location;
      if (!location) {
        prev[index] = '';
      }
      setSuggestions([]);
      return prev;
    });
    if (!location) {
      return;
    }
    const encodedLocation = encodeURIComponent(location); // Encode the location name to make it URL-safe
    const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodedLocation}.json?access_token=${mapboxgl.accessToken}`;

    try {
      const response = await axios.get(url);

      // If the response has results, update the coordinates
      if (response.data.features.length > 0) {
        const { center, place_name } = response.data.features[0]; // center holds the [longitude, latitude] array
        setSuggestions(response.data.features);
      }
    } catch (err) {
      // console.log({ lat, lng }); // Assign latitude and longitude
    }
  };
  const handleCloseCost = () => {
    setOpenPocModalCost(false);
    setRouteName('');
    setRingDescription('');
  };
  useEffect(() => {
    const execute = async () => {
      if (selectedRouteNavItem != null) {
        setRouteSelection(false);
      }
      await removePreviousLayersAndSourcesPoc();
      await fetchRoutesPoc();
    };
    execute();
    if (selectedRouteNavItem == null) {
      handleRefresh(map);
      cleanupRouteSelection();
    }
  }, [selectedRouteNavItem]);

  const fetchRoutesPoc = async () => {
    try {
      if (!map) {
        return;
      }
      if (!selectedRouteNavItem) {
        return;
      }
      console.log(selectedNav);
      const mapInstance = map.current;
      let routesData = await getRouteOneForPoc(selectedRouteNavItem);
      const coords = routesData[0].geoJSON.coordinates;
      const center = getCenterFromCoordinates(coords);
      map.current.flyTo({
        center,
        zoom: 8,
      });
      routesData.forEach((route, index) => {
        console.log(route);
        const routeGeoJSON = {
          type: 'Feature',
          geometry: {
            type: 'LineString',
            coordinates: route.geoJSON.coordinates, // Assuming geoJSON is directly available
          },
        };
        if (!mapInstance.getSource(`route-hitbox-${index}`)) {
          mapInstance.addSource(`route-hitbox-${index}`, {
            type: 'geojson',
            data: routeGeoJSON,
          });

          mapInstance.addLayer({
            id: `route-hitbox-layer-${index}`,
            type: 'line',
            source: `route-hitbox-${index}`,
            layout: {
              'line-join': 'round',
              'line-cap': 'round',
            },
            paint: {
              'line-color': 'transparent', // Make it invisible
              'line-width': 5, // Increase the width for the hitbox
            },
          });
        }
        // Check if source for the route already exists
        if (!mapInstance.getSource(`route-${index}`)) {
          mapInstance.addSource(`route-${index}`, {
            type: 'geojson',
            data: routeGeoJSON,
          });

          mapInstance.addLayer({
            id: `route-layer-${index}`,
            type: 'line',
            source: `route-${index}`,
            layout: {
              'line-join': 'round',
              'line-cap': 'round',
            },
            paint: {
              'line-color': '#fc6f03',
              'line-width': 5,
            },
          });
        }

        // Add hover effect for cursor pointer
        mapInstance.on('mouseenter', `route-hitbox-layer-${index}`, () => {
          mapInstance.getCanvas().style.cursor = 'pointer'; // Change cursor to pointer on hover
        });

        // Reset cursor when mouse leaves the route
        mapInstance.on('mouseleave', `route-hitbox-layer-${index}`, () => {
          mapInstance.getCanvas().style.cursor = ''; // Reset cursor style
        });
        mapInstance.on('click', `route-hitbox-layer-${index}`, (e) => {
          setSelectedRouteAdditional(route.id);
          setTotalRouteCost(route.totalCost);
          setRouteSelection(false);
          console.log(`Route clicked: ${route.id}`);
          const clickedPoint = e.lngLat; // Get clicked point's coordinates
          console.log('markers===>', mapMarkers);
          setMapMarkers((prevState) => {
            console.log('markers===>', prevState);

            if (prevState.length >= 2) {
              const isSamePoint =
                prevState.length > 0 &&
                prevState[prevState.length - 1].lng === clickedPoint.lng &&
                prevState[prevState.length - 1].lat === clickedPoint.lat;

              if (isSamePoint) {
                return prevState;
              }

              // If two markers are already present, clear them
              prevState.forEach((m) => m.marker.remove());
              console.log('====markers====', prevState);
              return [];
            } else if (prevState.length < 2) {
              // Create a new marker
              const isSamePoint =
                prevState.length > 0 &&
                prevState[prevState.length - 1].lng === clickedPoint.lng &&
                prevState[prevState.length - 1].lat === clickedPoint.lat;

              if (isSamePoint) {
                return prevState;
              }

              const marker = new mapboxgl.Marker()
                .setLngLat([clickedPoint.lng, clickedPoint.lat])
                .addTo(mapInstance);
              return [...prevState, { lng: clickedPoint.lng, lat: clickedPoint.lat, marker }];
            }
          });
        });
      });
      setOldSelectedNav(selectedRouteNavItem);

      let additional = await getRouteOneAdditionlForPoc(selectedRouteNavItem);
      console.log('additional===>', additional);
      additional.forEach((route, index) => {
        const routeGeoJSON = {
          type: 'Feature',
          geometry: {
            type: 'LineString',
            coordinates: route.geoJSON.coordinates, // Assuming geoJSON is directly available
          },
        };
        if (!mapInstance.getSource(`additional-route-${index}`)) {
          mapInstance.addSource(`additional-route-${index}`, {
            type: 'geojson',
            data: routeGeoJSON,
          });
          mapInstance.addLayer({
            id: `additional-route-layer-${index}`,
            type: 'line',
            source: `additional-route-${index}`,
            layout: {
              'line-join': 'round',
              'line-cap': 'round',
            },
            paint: {
              'line-color': '#000000',
              'line-width': 5,
            },
          });
        }
      });
    } catch (error) {
      console.error('Error fetching routes:', error);
    }
  };
  const removePreviousLayersAndSourcesPoc = async () => {
    if (!map) {
      return;
    }
    // if (!selectedRouteNavItem || !oldSelectedNav) return
    setRemoveMarkersSubRoute(true);
    const mapInstance = map.current;
    const routeLayerId = `route-layer-${0}`;
    const routeHitboxLayerId = `route-hitbox-layer-${0}`;
    const routeSourceId = `route-${0}`;
    const hitboxSourceId = `route-hitbox-${0}`;
    const countAdditional = await getRouteOneAdditionlCount(oldSelectedNav);

    // Remove route layers and sources if they exist
    if (mapInstance.getLayer(routeLayerId)) {
      mapInstance.removeLayer(routeLayerId);
    }
    if (mapInstance.getSource(routeSourceId)) {
      mapInstance.removeSource(routeSourceId);
    }
    if (mapInstance.getLayer(routeHitboxLayerId)) {
      mapInstance.removeLayer(routeHitboxLayerId);
    }
    if (mapInstance.getSource(hitboxSourceId)) {
      mapInstance.removeSource(hitboxSourceId);
    }
    removeAdditionalRoutes(mapInstance, countAdditional);
  };
  const handleCancel = () => {
    setMarkers((prevMarkers) => {
      // Remove all markers from the map
      prevMarkers.forEach((m) => {
        if (m?.marker) {
          m.marker.remove();
        }
      });
      return []; // Clear markers array
    });

    setRouteSelection(false);
    // setRoutePath(0);
    cancelAllRoutes();
    // setSystemOrOwnRoute('system');
    setCreateRoutePopup(false);
    setIsToggled(false);
    // setConnectToNetwork(false);

    // Clear route segments and selected segments
    setRouteSegments({});
    setSelectedSegments({});
    setShowRingConnection(false);
    setCurrentSegmentIndex(null);

    // Use the comprehensive cleanup function
    cleanupRouteSelection();
  };
  const handleLockRoute = async () => {
    // Check if we have selected segments for ring creation
    if (Object.keys(selectedSegments).length > 0) {
      try {
        // Don't show backdrop here - button loader is shown in the modal

        // Format rings from selectedSegments
        const rings = Object.keys(selectedSegments).map((segmentIndex) => {
          const routeData = selectedSegments[segmentIndex];
          const coordinates = routeData.geometry.coordinates;
          const startLocation = coordinates[0];
          const endLocation = coordinates[coordinates.length - 1];

          return {
            start_location: `${startLocation[1]}, ${startLocation[0]}`,
            end_location: `${endLocation[1]}, ${endLocation[0]}`,
            length: Math.round(routeData.distance),
            geoJSON: {
              type: 'LineString',
              coordinates: coordinates,
            },
          };
        });

        // Create ring data object
        const ringData = {
          name: routeName,
          description: ringDescription || '',
          network: currentKmzNetwork.toLowerCase(),
          rings: rings,
        };

        // Call the createRing API
        const resp = await createRing(ringData);
        resp && notify('success', 'Ring Created Successfully');
        handleCancel();
        if (getAllRoutes) {
          getAllRoutes();
        }
      } catch (err) {
        notify('error', err?.response?.data?.message || err.message || 'Something went wrong');
        throw err; // Re-throw to handle in modal
      }
    } else {
      notify('error', 'Please select routes for all segments first');
      console.log('No segments selected');
      throw new Error('No segments selected');
    }
  };
  const getRouteColor = (profile, index) => {
    const colors = {
      driving: ['#3887be', '#1e90ff', '#87cefa'], // Blue tones for driving
      walking: ['#00b300', '#66ff33', '#b3ff99'], // Green tones for walking
      cycling: ['#ff7f00', '#ff4500', '#ff6347'], // Orange tones for cycling
    };

    // Choose color based on the profile and index of the route
    return colors[profile][index] || '#000000'; // Default to black if something goes wrong
  };

  const handleRouteSelection = (selectedRouteData, index) => {
    const routeCoordinates = selectedRouteData.geometry?.coordinates || [];
    const startLocation = routeCoordinates.length > 0 ? routeCoordinates[0] : null;
    const endLocation =
      routeCoordinates.length > 0 ? routeCoordinates[routeCoordinates.length - 1] : null;

    const routeForState = {
      ...selectedRouteData.route,
      geometry: selectedRouteData.geometry, // Use the decoded geometry
      start: startLocation,
      end: endLocation,
      start_location: startLocation,
      end_location: endLocation,
    };

    setSelectedRoute(routeForState);
    setSelectedRouteIndex(index);

    // Clear multiple routes layer
    if (map.current.getLayer('multiple-routes')) {
      map.current.removeLayer('multiple-routes');
    }
    if (map.current.getSource('multiple-routes')) {
      map.current.removeSource('multiple-routes');
    }

    // Remove existing route layer and source if they exist
    if (map.current.getLayer('route-plot')) {
      map.current.removeLayer('route-plot');
    }
    if (map.current.getSource('route')) {
      map.current.removeSource('route');
    }
    const routeGeoJSON = {
      type: 'Feature',
      geometry: {
        type: 'LineString',
        coordinates: routeCoordinates || [],
      },
    };

    console.log('Route GeoJSON:', routeGeoJSON);
    console.log('Coordinates length:', routeCoordinates?.length);

    try {
      map.current.addSource('route', {
        type: 'geojson',
        data: routeGeoJSON,
      });
      console.log('Source added successfully');

      // Wait for source to load before adding layer
      map.current.on('sourcedata', (e) => {
        if (e.sourceId === 'route' && e.isSourceLoaded) {
          if (!map.current.getLayer('route-plot')) {
            map.current.addLayer({
              id: 'route-plot',
              type: 'line',
              source: 'route',
              layout: {
                'line-join': 'round',
                'line-cap': 'round',
              },
              paint: {
                'line-color': selectedRouteData.color,
                'line-width': 8,
              },
            });
            console.log('Layer added successfully');
          }
        }
      });

      // Also try to add layer immediately
      if (!map.current.getLayer('route-plot')) {
        map.current.addLayer({
          id: 'route-plot',
          type: 'line',
          source: 'route',
          layout: {
            'line-join': 'round',
            'line-cap': 'round',
          },
          paint: {
            'line-color': selectedRouteData.color,
            'line-width': 8,
          },
        });
        console.log('Layer added immediately');
      }
    } catch (error) {
      console.error('Error adding route to map:', error);
    }
  };

  // New function to handle segment route selection
  const handleSegmentRouteSelection = (segmentIndex, routeData) => {
    // Update selected segment
    setSelectedSegments((prev) => ({
      ...prev,
      [segmentIndex]: routeData,
    }));

    // Render the selected route for this segment
    renderSegmentRoute(segmentIndex, routeData);

    // Close the route selection popup
    setShowRouteSelectionPopup(false);
    setCurrentSegmentIndex(null);
  };

  // Function to show route selection popup for a specific segment
  const showSegmentRouteSelection = (segmentIndex) => {
    const segmentRoutes = routeSegments[segmentIndex];
    if (segmentRoutes && segmentRoutes.length > 0) {
      setMultipleRoutes(segmentRoutes);
      setCurrentSegmentIndex(segmentIndex);
      setShowRouteSelectionPopup(true);
    }
  };

  const handleClose = () => {
    setOpenCost(false);
  };
  const cleanupAfterCostAdded = () => {
    // Remove markers
    setMapMarkers((prevState) => {
      prevState.forEach((m) => m.marker.remove());
      return [];
    });

    // Remove route layers
    if (map.current) {
      // Remove route-plot layer and source
      if (map.current.getLayer('route-plot')) {
        map.current.removeLayer('route-plot');
      }
      if (map.current.getSource('route')) {
        map.current.removeSource('route');
      }

      // Remove multiple-routes layer and source
      if (map.current.getLayer('multiple-routes')) {
        map.current.removeLayer('multiple-routes');
      }
      if (map.current.getSource('multiple-routes')) {
        map.current.removeSource('multiple-routes');
      }

      // Remove selected-route layer and source
      if (map.current.getLayer('selected-route')) {
        map.current.removeLayer('selected-route');
      }
      if (map.current.getSource('selected-route')) {
        map.current.removeSource('selected-route');
      }
    }

    // Clear route selection states
    setSelectedRoute(null);
    setMultipleRoutes([]);
    setShowRouteSelectionPopup(false);
    setSelectedRouteIndex(null);
    setAlternativeRoutes([]);
    setRouteSelection(false);

    // Clear markers state
    setMarkers([]);
  };
  const cleanupRouteSelection = () => {
    // Remove all markers
    setMapMarkers((prevState) => {
      prevState.forEach((m) => m.marker.remove());
      return [];
    });

    // Remove route layers
    if (map.current) {
      // Remove route-plot layer and source
      if (map.current.getLayer('route-plot')) {
        map.current.removeLayer('route-plot');
      }
      if (map.current.getSource('route')) {
        map.current.removeSource('route');
      }

      // Remove multiple-routes layer and source
      if (map.current.getLayer('multiple-routes')) {
        map.current.removeLayer('multiple-routes');
      }
      if (map.current.getSource('multiple-routes')) {
        map.current.removeSource('multiple-routes');
      }

      // Remove selected-route layer and source
      if (map.current.getLayer('selected-route')) {
        map.current.removeLayer('selected-route');
      }
      if (map.current.getSource('selected-route')) {
        map.current.removeSource('selected-route');
      }

      // Remove all segment route layers
      clearAllRouteLayers();
    }

    // Clear route selection states
    setSelectedRoute(null);
    setMultipleRoutes([]);
    setShowRouteSelectionPopup(false);
    setSelectedRouteIndex(null);
    setAlternativeRoutes([]);
    setRouteSelection(false);

    // Clear new pairwise segment states
    setRouteSegments({});
    setSelectedSegments({});
    setShowRingConnection(false);
    setCurrentSegmentIndex(null);

    // Clear markers state
    setMarkers([]);

    // Clear additional route states
    setSelectedRouteAdditional(null);
    setTotalRouteCost(null);
  };
  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <div ref={mapContainer} style={{ width: '100%', height: '100%' }} />
      <div
        style={{
          position: 'absolute',
          top: '10px',
          left: '10px',
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          zIndex: 1,
        }}
      >
        <div data-svg-wrapper style={{ marginLeft: '5px' }}>
          <KmzButtonsComponent />
        </div>
      </div>
      {createRoutePopup ? (
        <div
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            zIndex: 1,
          }}
        >
          <div data-svg-wrapper style={{ marginRight: '5px' }}>
            <CreateRingRoute
              createRoutePopup={createRoutePopup}
              setAlternativeRoutes={setAlternativeRoutes}
              strArr={setStrArray}
              handleLockRoute={handleLockRoute}
              handleToggle={handleToggle}
              setIsToggled={setIsToggled}
              loadonMap={loadonMap}
              alternativeRoutes={alternativeRoutes}
              setCreateRoutePopup={setCreateRoutePopup}
              cancelAllRoutes={cancelAllRoutes}
              handleRemoveItem={handleRemoveItem}
              setMarkers={setMarkers}
              setMapMarkers={setMapMarkers}
              strArray={strArray}
              markers={markers}
              suggestions={suggestions}
              handleSearch={handleSearch}
              routeSegments={routeSegments}
              selectedSegments={selectedSegments}
              setRouteSegments={setRouteSegments}
              setSelectedSegments={setSelectedSegments}
              showRingConnection={showRingConnection}
              setShowRingConnection={setShowRingConnection}
              showSegmentRouteSelection={showSegmentRouteSelection}
              clearAllRouteLayers={clearAllRouteLayers}
              handleSegmentRouteSelection={handleSegmentRouteSelection}
            />
          </div>
        </div>
      ) : (
        <AddRouteButton setCreateRoutePopup={setCreateRoutePopup} />
      )}
      <PartnerAndNetwrokButtons map={map} onlyNetwork={true} />
      <RefreshMap map={map} />
      <RingNameModal
        open={openPocModalCost}
        handleClose={handleCloseCost}
        handleLockRoute={handleLockRoute}
        getAllRoutes={getAllRoutes}
        setRouteName={setRouteName}
        routeName={routeName || ''}
        ringDescription={ringDescription || ''}
        setRingDescription={setRingDescription}
      />
      <PocEstimationModal
        open={openCost}
        submitAdditional={submitAdditional}
        setSubmitAdditional={setSubmitAdditional}
        getAllRoutes={getAllRoutes}
        setRemoveMarkersSubRoute={setRemoveMarkersSubRoute}
        handleClose={handleClose}
        selectRoute={selectedRoute}
        selectedRouteAdditional={selectedRouteAdditional}
        cleanupAfterCostAdded={cleanupAfterCostAdded}
        isRingCost={true}
        selectedRingAdditional={selectedRingId}
      />

      {/* Route Selection Popup */}
      {showRouteSelectionPopup && multipleRoutes.length > 0 && (
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            background: 'white',
            borderRadius: '8px',
            padding: '20px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
            zIndex: 1000,
            maxWidth: '400px',
            maxHeight: '80vh',
            overflow: 'auto',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '15px',
            }}
          >
            <h3 style={{ margin: 0, color: '#333' }}>
              {currentSegmentIndex !== null
                ? `Select Route for Segment ${currentSegmentIndex + 1} → ${currentSegmentIndex + 2}`
                : 'Select Route'}
            </h3>
            <button
              onClick={() => {
                setShowRouteSelectionPopup(false);
                setMultipleRoutes([]);
                // Clear multiple routes layer
                if (map.current.getLayer('multiple-routes')) {
                  map.current.removeLayer('multiple-routes');
                }
                if (map.current.getSource('multiple-routes')) {
                  map.current.removeSource('multiple-routes');
                }
              }}
              style={{
                background: 'none',
                border: 'none',
                fontSize: '20px',
                cursor: 'pointer',
                color: '#666',
              }}
            >
              ×
            </button>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {multipleRoutes.map((routeData, index) => (
              <div
                key={index}
                onClick={() => {
                  if (currentSegmentIndex !== null) {
                    handleSegmentRouteSelection(currentSegmentIndex, routeData);
                  } else {
                    handleRouteSelection(routeData, index);
                  }
                }}
                style={{
                  padding: '12px',
                  border: selectedRouteIndex === index ? '2px solid #007bff' : '1px solid #ddd',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  transition: 'background-color 0.2s',
                  backgroundColor: selectedRouteIndex === index ? '#f0f8ff' : 'white',
                }}
                onMouseEnter={(e) => {
                  if (selectedRouteIndex !== index) {
                    e.target.style.backgroundColor = '#f5f5f5';
                  }
                }}
                onMouseLeave={(e) => {
                  if (selectedRouteIndex !== index) {
                    e.target.style.backgroundColor = 'white';
                  }
                }}
              >
                <div
                  style={{
                    width: '20px',
                    height: '4px',
                    backgroundColor: routeData.color,
                    borderRadius: '2px',
                  }}
                />
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 'bold', color: '#333' }}>
                    {selectedRouteIndex === index && (
                      <span style={{ color: '#007bff', marginLeft: '8px' }}>✓ Selected</span>
                    )}
                  </div>
                  <div style={{ fontSize: '12px', color: '#666' }}>
                    Duration: {Math.round(routeData.duration / 60)} min | Distance:{' '}
                    {(routeData.distance / 1000).toFixed(1)} km
                  </div>
                </div>
              </div>
            ))}

            {selectedRouteIndex !== null && (
              <button
                onClick={() => {
                  setShowRouteSelectionPopup(false);
                  setMultipleRoutes([]);
                  setSelectedRouteIndex(null);
                }}
                style={{
                  marginTop: '15px',
                  padding: '10px 20px',
                  backgroundColor: '#007bff',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: 'bold',
                }}
              >
                Confirm Selection
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default RingPlanningMap;
